import { Lightbulb } from 'lucide-react'
import { getCurrentUser } from '../utils/utils'

export default function EmptyDashboard() {

  return (
    <div className="flex flex-col flex-1  p-0">
      <div className="flex items-center justify-between bg-white px-4 py-2 shadow-sm border-b">
        {/* Left: icon and Breadcrumbs */}
        <div className="flex items-center space-x-6">
          <div className="flex items-center space-x-2">
            <Lightbulb />
            <span className="font-bold text-lg">Dashboard</span>
          </div>

        </div>

      </div>

      <div className="h-[calc(100vh-55px)] bg-gray-100 ">
        <div className='bg-white h-full  rounded-lg m-2 p-2'>
          <div className='text-left mt-2'>
            <b className='text-2xl'>Hi {getCurrentUser()?.name??"User"},</b>
            <p>Welcome Back</p>
          </div>
        </div>
      </div>
    </div>
  )
}
